export const newAssignmentModule = {
  state: () => ({}),
  mutations: {},
  actions: {},
  getters: {},
};